import axiosInstance from "../../utils/axios"

export const getSummaryData = async (value) => {
    let res = await axiosInstance.post(`progress/test`, value)
    return res
}
export const getInstallStatsReport = async (data) => {
    let res = await axiosInstance.get(
        `/progress/installed_stats/activity?activity_id=${data?.actId}&start_date=${data?.startDate}&end_date=${data?.endDate}`
    );
    return res
}
export const getInstallStatsDownloadReport = async () => {
    let res = await axiosInstance.get('/progress/installed_stats_download?activity_id=all');
    return res
}